module.exports = __webpack_public_path__ + "src/app/assets/images/sug-lagoon.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/sug-lagoon.jpg
// module id = 623
// module chunks = 0